/** Resolve the payment transaction, which may be nested in the booking response. */
export function getRentPaymentTransaction(response: any): {
  transactionId: string;
  referenceId: string;
} {
  const data = response?.data || response;
  const transaction = data?.transaction;
  const candidates = [
    transaction?.id,
    transaction?._id,
    transaction,
    data?.transactionId,
    data?.id,
    data?._id,
  ];
  const transactionId = candidates.find(
    (value) => typeof value === "string" && value.trim().length > 0,
  ) || "";
  const referenceId = transaction?.referenceId || data?.referenceId;
  return {
    transactionId,
    referenceId: typeof referenceId === "string" ? referenceId : "",
  };
}

/** Read the server bill; never recalculate an amount used for payment. */
export function getRentBill(response: any): any | null {
  const data = response?.data || response;
  const transaction = data?.transaction;
  const bill = transaction?.bill ?? data?.bill;
  const value = Array.isArray(bill) ? bill[0] : bill;
  return value && Number.isFinite(Number(value.total)) && value.total != null ? value : null;
}
